import { createEvent, restore, sample } from 'effector'
import { fx } from 'src/libs'
import { normalizeObject } from 'src/pages/finSystem/balanceSummary/reports/utils'
import {
  CommissionFilter,
  ApiListResponse,
  Commission,
} from 'src/pages/finSystem/balanceSummary/reports/reportCommissions/types'

export const commissionListLoad = createEvent<CommissionFilter>()

export const getCommissionListFx = fx<any | void, ApiListResponse<Commission>>({
  method: 'GET',
  url: `/finance/report/commission`,
})

export const $commissionList = restore<ApiListResponse<Commission>>(
  getCommissionListFx.doneData.map((res) => res.body),
  null,
)

export const $walletOptions = $commissionList.map((data) => {
  if (!data) return []

  const map = new Map<number, { label: string; value: string }>()

  data.items.forEach((item) => {
    if (!map.has(item.walletId)) {
      map.set(item.walletId, {
        label: item.walletName,
        value: String(item.walletId),
      })
    }
  })
  return Array.from(map.values())
})

export const $currencyOptions = $commissionList.map((data) => {
  if (!data) return []

  const map = new Map<string, { label: string; value: string }>()

  data.items.forEach((item) => {
    item.currencies.forEach((currencyItem) => {
      if (!map.has(currencyItem.currency)) {
        map.set(currencyItem.currency, {
          label: currencyItem.currency,
          value: currencyItem.currency,
        })
      }
    })
  })

  return Array.from(map.values())
})

sample({
  clock: commissionListLoad,
  fn: (filters) => {
    const requestObject = normalizeObject(filters)

    if (!requestObject || Object.keys(requestObject).length === 0) {
      return {}
    }
    const query: any = {}

    const { sorterField, ...rest } = requestObject

    if (sorterField) query['order'] = requestObject.sorterField
    if (Object.keys(rest).length !== 0) query['where'] = JSON.stringify(rest)

    return { query }
  },
  target: getCommissionListFx,
})
